<template>
  <div class="space-y-3">
    <template v-for="(block, idx) in blocks" :key="idx">
      <!-- Simple text / bold -->
      <p v-if="block.text" class="text-[15px]">
        <template v-if="block.bold">
          <strong class="font-bold">{{ block.text }}</strong>
        </template>
        <template v-else>{{ block.text }}</template>
      </p>

      <!-- Text with parts (inline bold) -->
      <p v-else-if="block.parts" class="text-[15px]">
        <template v-for="(part, i) in block.parts" :key="i">
          <strong v-if="part.bold" class="font-bold">{{ part.text }}</strong>
          <template v-else>{{ part.text }}</template>
        </template>
      </p>

      <!-- Subheading -->
      <p v-else-if="block.heading" class="text-[15px] font-bold">{{ block.heading }}</p>

      <!-- List -->
      <template v-else-if="block.list">
        <p v-for="(item, i) in block.list" :key="i" class="text-[15px]">
          {{ item }}
        </p>
      </template>

      <!-- Link -->
      <p v-else-if="block.link" class="text-[15px]">
        <a
          :href="block.link.href"
          target="_blank"
          rel="noopener noreferrer"
          class="text-primary-600 hover:underline"
        >
          {{ block.link.text }}
        </a>
      </p>

      <!-- Info categories table -->
      <template v-else-if="block.categories">
        <article
          v-for="(category, cIdx) in block.categories"
          :key="cIdx"
          class="border border-solid border-primary-100 rounded overflow-hidden"
        >
          <header
            class="flex flex-col gap-2 border-b border-solid border-primary-100 bg-white p-4"
          >
            <p class="text-body-xs font-bold">Information category</p>
            <h4
              class="font-heading text-h4 tablet:text-h4-tablet laptop:text-h4-desktop"
            >
              {{ category.title }}
            </h4>
          </header>
          <div class="space-y-3 bg-white p-4">
            <h5
              class="font-heading text-h5 tablet:text-h5-tablet laptop:text-h5-desktop text-dark"
            >
              Nature of Information Collected
            </h5>
            <p v-for="(item, i) in category.nature" :key="'n-' + i" class="text-[15px]">
              {{ item }}
            </p>
            <h5
              class="font-heading text-h5 tablet:text-h5-tablet laptop:text-h5-desktop text-dark"
            >
              Example and Purpose
            </h5>
            <p v-for="(item, i) in category.purpose" :key="'p-' + i" class="text-[15px]">
              {{ item }}
            </p>
          </div>
        </article>
      </template>
    </template>
  </div>
</template>

<script setup>
defineProps({
  blocks: {
    type: Array,
    default: () => []
  }
})
</script>
